import { submitForm } from '../utils/form-submit';
import { showToast } from '../utils/toast';

export function contactForm() {
  const form = document.querySelector('.wp-block-contact-form form');

  if (typeof window.grecaptcha === 'undefined') {
    console.error('reCAPTCHA not loaded');
    showToast(window.js_localizations.captcha_error_message, 5000);
    return;
  }

  window.grecaptcha.ready(() => {
    form.addEventListener('submit', (event) => {
      event.preventDefault();

      window.grecaptcha
        .execute(window.js_localizations.recaptcha_site_key, { action: 'contact_submit' })
        .then((token) => {
          submitForm({
            form,
            url: window.js_localizations.contact_submission_url,
            extraFields: { recaptcha_token: token },
            event: 'generate_lead',
            eventData: { form_name: 'contact_form', lead_type: 'contact_inquiry' },
            onSuccess: () => {
              form.reset();
              window.scrollTo({ top: 0, behavior: 'smooth' });
            },
          });
        })
        .catch((error) => {
          console.error('reCAPTCHA error:', error);
          showToast(window.js_localizations.captcha_error_message, -1);
        });
    });
  });
}
